"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queueTimeTranslations = {
    "en": {
        average: "Average",
        maximum: "Maximum",
        queueTime: "Queue Time",
        infoText: "The average and maximum queue times for the specified date range. You may customize the\n        graph colors by setting the Service Level Agreement (SLA) thresholds.",
    },
    "de": {
        infoText: "Die durchschnittlichen und maximalen Wartezeiten f\u00FCr den angegebenen Zeitraum. Sie k\u00F6nnen die Diagrammfarben anpassen,\n        indem Sie die Grenzwerte des Service Level Agreement (SLA) einstellen.",
        average: "Durchschnittlich",
        queueTime: "Wartezeit",
        maximum: "Maximal",
    },
    "nl": {
        infoText: "De gemiddelde en maximale tijden in de rij voor het opgegeven datumbereik. U kunt de\n        grafiekkleuren aanpassen door de Service Level Agreement (SLA) grenzen in te stellen.",
        average: "Gemiddeld",
        queueTime: "Tijd in de rij",
        maximum: "Maximaal",
    },
    "it": {
        infoText: "Il tempo in coda medio e massimo per il periodo specificato. Puoi personalizzare i\n        colori del grafico impostando le soglie del Contratto di Servizio (SLA in inglese).",
        average: "Medio",
        queueTime: "Tempo in coda",
        maximum: "Massimo",
    },
    "fr": {
        infoText: "Les temps en file d'attente moyen et maximal pour la plage de dates sp\u00E9cifi\u00E9e. Vous pouvez personnaliser les\n        couleurs du graphe en r\u00E9glant les seuils de l'entente de niveau de service (ENS).",
        average: "Moyenne",
        queueTime: "Temps en file d'attente",
        maximum: "Maximum",
    },
    "es": {
        infoText: "El tiempo medio de espera en la cola y el tiempo m\u00E1ximo de espera en la cola para el intervalo de fecha indicado. Usted puede personalizar los\n        colores de los gr\u00E1ficos ajustando los l\u00EDmites del Acuerdo de Nivel de Servicio (ANS).",
        average: "Promedio",
        queueTime: "Tiempo de espera en la cola",
        maximum: "Máximo",
    },
    "ja": {
        infoText: "\u6307\u5B9A\u3055\u308C\u305F\u30C7\u30FC\u30BF\u7BC4\u56F2\u306B\u304A\u3051\u308B\u5E73\u5747\u30AD\u30E5\u30FC\u901A\u8A71\u6642\u9593\u304A\u3088\u3073\u6700\u9577\u30AD\u30E5\u30FC\u6642\u9593\u30B0\u30E9\u30D5\u306E\u8272\u306F\n        \u30B5\u30FC\u30D3\u30B9\u30EC\u30D9\u30EB\u5408\u610F\uFF08SLA\uFF09\u306E\u3057\u304D\u3044\u5024\u3092\u8A2D\u5B9A\u3057\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002",
        average: "平均",
        queueTime: "キュー時間",
        maximum: "最長",
    },
    "en-GB": {
        infoText: "The average and maximum queue times for the specified date range. You may customise the\n        graph colours by setting the Service Level Agreement (SLA) thresholds.",
        average: "Average",
        queueTime: "Queue Time",
        maximum: "Maximum",
    },
    "ru": {
        average: "Среднее",
        maximum: "Максимальное",
        queueTime: "Время Ожидания",
        infoText: "\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0438 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0432 \u043E\u0447\u0435\u0440\u0435\u0434\u0438 \u0437\u0430 \u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0435\u0436\u0443\u0442\u043E\u043A \u0432\u0440\u0435\u043C\u0435\u043D\u0438. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435\n         \u043A\u0430\u0441\u0442\u043E\u043C\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0446\u0432\u0435\u0442\u0430 \u0433\u0440\u0430\u0444\u0438\u043A\u043E\u0432 \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 C\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u043E\u0431 \u0423\u0440\u043E\u0432\u043D\u0435 \u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F (\u0421\u0423\u041E).",
    },
};
